import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
    const { user } = useAuth();
    const location = useLocation();
    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center text-[var(--rom-text-2)]">
                <div className="text-sm">Loading…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
    if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
    return children;
}
